import { Injectable } from '@angular/core';

import { PlayerSidenavComponent } from '../player-sidenav';

@Injectable({
  providedIn: 'root'
})
export class PlayerSidenavReferencesService {

  private references: Map<string, PlayerSidenavComponent>;

  constructor() {
    this.references = new Map();
  }

  set(key: string, playerSidenav: PlayerSidenavComponent) {
    this.references[key] = playerSidenav;
  }

  get(key: string): PlayerSidenavComponent {
    return this.references[key];
  }

}


